<ng-container
  *ngIf="{
    isLoaded: isLoaded$ | async,
    isMobile: isMobile$ | async,
    isLoading: isLoading$ | async,
    orders: orders$ | async,
  } as obs"
>
  @if (!hideFilter()) {
    @if (obs.isMobile) {
      <button class="mobile-filter" (click)="openFiltersModal()">
        <sd-icon class="icon-size-s" type="filter"></sd-icon>
        <span>фильтры</span>
      </button>
    } @else {
      <sd-online-orders-filter></sd-online-orders-filter>
    }
  }

  @if (obs.isLoading) {
    @for (item of [].constructor(8); track $index) {
      <div class="order-history-item-skeleton"></div>
    }
  } @else if (obs.orders) {
    @for (order of obs.orders.orders; track order.code) {
      <sd-order-list-item [routerLink]="['/my-account/order/', order.code]" [order]="order"></sd-order-list-item>
    } @empty {
      <sd-no-orders-block></sd-no-orders-block>
    }
    <div *ngIf="obs.orders?.pagination && obs.orders.pagination.totalResults > 0" class="pagination-wrapper">
      <sd-pagination
        uiRestoreScrollPosition
        [pagination]="obs.orders.pagination"
        (viewPageEvent)="changePage($event)"
        [defaultPage]="0"
      ></sd-pagination>
    </div>
  }
</ng-container>
